module.exports = __webpack_public_path__ + "static/img/smile_ddd.4508b72.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/smile_ddd.png
// module id = Fa1K
// module chunks = 1